import React, { Component } from "react";
import { observer } from "mobx-react";
import moment from "moment";
import OrderDetailDeliveryInfo from "./OrderDetailDeliveryInfo";
import {
  comma,
  partnerIcon,
  apiMobileOrderFg,
  baeminMobileOrderFg,
  baerminUseYn,
  posOrdermMbileOrderFg,
} from "../../..//utils/Utils";
import { fn_change_addr, fn_closeDetailView, fn_orderDetailMemo } from "../../../function/FnBodyDetail";
import { fn_scroll_down, fn_scroll_up } from "../../../function/FnScroll";
import { fn_bridge_order_change } from "../../../function/FnPosBridge";
import OrderDetailButton from "./OrderDetailButton";
import BaeminOrderDetailButton from "./BaeminOrderDetailButton";
import PosOrderDetailButton from "./PosOrderDetailButton";

@observer
class OrderDetail extends Component {
  constructor(props) {
    super(props);
    this.orderInfo = React.createRef();
    this.menuInfo = React.createRef();
  }

  render() {
    const { rootStore } = this.props;

    let viewStore = this.props.rootStore.viewStore;
    let order = this.props.rootStore.viewStore.getOrderDetail;
    let checkCallBack = order.mobileOrderFg === "29" || order.mobileOrderFg === "30" ? true : false;

    if (order.partnerType == "BAEMIN") {
      if (order.morderTypeCd == "P") {
        order.partnerType = "BAEMIN_PICKUP";
      } else if (order.morderTypeCd == "O") {
        order.partnerType = "BAEMIN_SHOP";
      }
    }
    let img_icon = partnerIcon(order.partnerType);

    let orderText;
    switch (order.stepType) {
      case "READY":
        orderText = "주문 접수 전";
        break;
      case "COOKING":
        if (order.orderType === "DELIVERY") {
          orderText = "배차전";
        } else if (order?.orderType === "PICKUP" || order?.orderType === "TABLE") {
          if (order.mobileOrderFg === "30") {
            orderText = "진행중";
          } else {
            orderText = "조리중";
          }
        }
        break;
      case "DELIVERY":
        if (order.orderType === "DELIVERY") {
          if (order.dlvStatusFg === "00" || order.dlvStatusFg === "01") {
            if (order.mobileOrderFg == "30") {
              orderText = "진행중";
            } else {
              orderText = "배차중";
            }
          } else if (order.dlvStatusFg === "02") {
            orderText = "픽업중";
          } else if (order.dlvStatusFg === "03") {
            orderText = "배달중";
          } else if (order.dlvStatusFg === "04") {
            orderText = "배달완료";
          } else if (order.mobileOrderFg == "32" && order.stepCd == "500") {
            orderText = "배달중";
          } else {
            orderText = "배차전";
          }
        } else if (order?.orderType === "PICKUP" || order?.orderType === "TABLE") {
          if (checkCallBack) {
            orderText = "조리중";
          } else if (order.mobileOrderFg === "30") {
            orderText = "진행중";
          } else {
            orderText = "호출";
          }
        }
        break;
    }
    //orderType:배달(DELIVERY), 포장(PICKUP), 테이블(TABLE).

    let orderTypeStyle;
    switch (order?.orderType) {
      case "DELIVERY":
        orderTypeStyle = "type delivery";
        break;
      case "PICKUP":
        orderTypeStyle = "type takeout";
        break;
      case "TABLE":
        orderTypeStyle = "type table";
        break;
      default:
        orderTypeStyle = "type";
        break;
    }

    let payText;
    switch (order.payType) {
      case "PAID":
        payText = "(결제완료)";
        break;
      case "NO_PAID":
        if (order.payFg === "CARD") {
          payText = "(후불카드)";
        } else if (order.payFg === "CASH") {
          payText = "(후불현금)";
        } else if (order.payFg === "OTHER") {
          payText = "(후불복합)";
        }
        break;
    }

    return (
      <>
        <div className={"layer_comm layer_order_detail " + (viewStore.getDetailView ? " layer_open" : "")}>
          <div className="bg"></div>
          <div className={"layer_content " + (viewStore.getDetailBaeminView ? " layer_open" : "")}>
            <div className="article_order_detail">
              <h1 className="section_tit">
                <span className="thumb">
                  <img src={img_icon} width="40" height="40" alt={"logo"} />
                  <span className="frame"></span>
                </span>
                <span className={orderTypeStyle}>
                  {order?.selfDeliveryType != null && order?.selfDeliveryType != ""
                    ? order?.selfDeliveryType
                    : order?.orderTypeView}
                </span>
                <span className="bar"></span>
                <span className="name">
                  <strong>
                    {order.mobileOrderFg == "23" || apiMobileOrderFg(order?.mobileOrderFg)
                      ? order.orderNo
                      : baeminMobileOrderFg(order?.mobileOrderFg)
                      ? order?.mobileOrderNo?.slice(-4)
                      : order?.mobileOrderNoView}
                  </strong>
                  <span>({order.orderTimeView})</span>
                </span>
                <span className="status">{orderText}</span>
                {baeminMobileOrderFg(order?.mobileOrderFg) &&
                baerminUseYn(rootStore) &&
                rootStore.searchStore.getSession.connPosNo !=
                  rootStore.settingStore.getBaeminUseStatus.baeminUsePosNo ? (
                  <span className="baeminInfo"></span>
                ) : (
                  ""
                )}
              </h1>
              <div className="section_content">
                <div className="clear_g">
                  <div className="wrap_order_info">
                    <div className="box_tit">
                      <h2>주문정보</h2>
                      <div className="btns">
                        {order.partnerType != "CID" ? (
                          order?.orderType === "DELIVERY" &&
                          order.stepCd !== "500" &&
                          order.stepCd !== "700" &&
                          order.stepCd !== "900" &&
                          order.mobileOrderFg != "29" ? (
                            <button
                              className="juso"
                              onClick={event => {
                                rootStore.viewStore.setDetailSearchAddr(order.dlvAddrFull);
                                fn_change_addr(rootStore);
                              }}
                            >
                              주소수정
                            </button>
                          ) : (order.dlvStatusFg === null || order.dlvStatusFg === "99") && order.stepCd === "500" ? (
                            <button
                              className="juso"
                              onClick={event => {
                                rootStore.viewStore.setDetailSearchAddr(order.dlvAddrFull);
                                fn_change_addr(rootStore);
                              }}
                            >
                              주소수정
                            </button>
                          ) : null
                        ) : null}
                        {order.partnerType === "CID" &&
                        order.payType !== "PAID" &&
                        order.stepCd !== "700" &&
                        order.stepCd !== "900" &&
                        (order.stepType === "COOKING" ||
                          order.dlvStatusFg === "99" ||
                          order.dlvStatusFg === null ||
                          order.dlvStatusFg === "null") ? (
                          <button
                            onClick={event => {
                              fn_bridge_order_change(rootStore, "M");
                            }}
                            className="size"
                          >
                            주문/결제변경
                          </button>
                        ) : null}
                        <button onClick={event => fn_orderDetailMemo(rootStore)}>메모입력</button>
                      </div>
                    </div>
                    <div className="inner">
                      <div className="scroll_h_full scroll_hidden" ref={this.orderInfo}>
                        <dl className="list_info">
                          <dt>주문일시</dt>
                          <dd>{moment(order.orderTime, "YYYYMMDDHHmmss").format("YYYY/MM/DD HH:mm:ss")}</dd>
                        </dl>
                        <dl className="list_info">
                          <dt>채널주문번호</dt>
                          <dd>{order.mobileOrderNo}</dd>
                        </dl>
                        {order.bellNo || order.deliverNo ? (
                          <dl className="list_info">
                            <dt>진동벨번호</dt>
                            <dd>{"진동벨 " + (order.bellNo || order.deliverNo)}</dd>
                          </dl>
                        ) : null}
                        {order.registNumber ? (
                          <dl className="list_info">
                            <dt>채널접수번호</dt>
                            <dd>
                              {order?.morderTypeCd == "P" && order?.mobileOrderFg === "28"
                                ? "접수번호 " + order.registNumber
                                : order.registNumber}
                            </dd>
                          </dl>
                        ) : null}
                        {order.waitingNo ? (
                          <dl className="list_info">
                            <dt>채널대기번호</dt>
                            <dd>{"대기번호 " + order.waitingNo}</dd>
                          </dl>
                        ) : null}
                        {order.tableNo ? (
                          <dl className="list_info">
                            <dt>테이블번호</dt>
                            <dd>{"테이블 " + order.tableNo}</dd>
                          </dl>
                        ) : null}
                        {order.tableNo ? (
                          <dl className="list_info">
                            <dt>최종주문차수</dt>
                            <dd>{`${
                              order.maxOidSeqNo > 0 ? order.maxOidSeqNo.toString().padStart(3, "0") : "001"
                            } 차수`}</dd>
                          </dl>
                        ) : null}
                        <dl className="list_info">
                          <dt>포스주문번호</dt>
                          <dd>
                            {moment(order.saleDate, "YYYYMMDDHHmmss").format("YYYY/MM/DD") +
                              " " +
                              (!order.orderNo ? "[없음]" : order.orderNo)}
                          </dd>
                        </dl>
                        {order.mobileOrderFg === "27" &&
                        order?.morderTypeCd == "P" &&
                        order?.expectedPickupTime != "" &&
                        !order?.isInputCookingTime ? (
                          <dl className="list_info">
                            <dt>픽업예정시간</dt>
                            <dd>{moment(order.expectedPickupTime, "YYYYMMDDHHmmss").format("YYYY/MM/DD HH:mm:ss")}</dd>
                          </dl>
                        ) : order.cookTime != "" && order.cookTime != "0" ? (
                          <dl className="list_info">
                            <dt>
                              {order?.morderTypeCd == "D"
                                ? order?.mobileOrderFg == "31"
                                  ? "픽업예상시간"
                                  : "배달예상시간"
                                : "준비예상시간"}
                            </dt>
                            <dd>{order.cookTime} 분</dd>
                          </dl>
                        ) : null}
                        {order.billNo != null ? (
                          <dl className="list_info">
                            <dt>포스영수번호</dt>
                            <dd>
                              {moment(order.saleDate, "YYYYMMDDHHmmss").format("YYYY/MM/DD") + " " + order.billNo}
                            </dd>
                          </dl>
                        ) : null}
                        {order.visitorNo ? (
                          <dl className="list_info">
                            <dt>방문인원수</dt>
                            <dd>{order.visitorNo + "명"}</dd>
                          </dl>
                        ) : null}
                        {order?.orderType === "DELIVERY" ? (
                          <>
                            {order?.dlvAddrFull != null && order?.dlvAddrFull.trim() != "" ? (
                              <dl
                                className={
                                  "list_info " + (rootStore.viewStore.getSelectedAddr != null ? "blue" : "list_error")
                                }
                              >
                                <dt>주소</dt>
                                <dd className="address">
                                  {order?.mobileOrderFg == "29"
                                    ? order?.dlvAddr
                                      ? order?.dlvAddr
                                      : ""
                                    : order?.dlvAddrFull
                                    ? order?.dlvAddrFull
                                    : ""}
                                </dd>
                              </dl>
                            ) : (
                              <dl className={"list_info list_error"}>
                                <dt>주소</dt>
                                <dd className="null">주소 정보가 없습니다.</dd>
                              </dl>
                            )}
                            {order?.addr2 && order?.mobileOrderFg != "29" ? (
                              <dl
                                className={
                                  "list_info " + (rootStore.viewStore.getSelectedAddr != null ? "blue" : "list_error")
                                }
                              >
                                <dt>도로명</dt>
                                <dd className="address">
                                  {order?.addr2}
                                  {order?.dlvAddrDetail ? " " + order?.dlvAddrDetail : null}
                                </dd>
                              </dl>
                            ) : null}
                          </>
                        ) : null}
                        {order?.cstNm ? (
                          <dl className="list_info">
                            <dt>고객명</dt>
                            <dd className="address">{order.cstNm}</dd>
                          </dl>
                        ) : (
                          <dl className="list_info">
                            <dt>고객명</dt>
                            <dd className="null">고객명 정보가 없습니다.</dd>
                          </dl>
                        )}
                        <dl className="list_info">
                          <dt>연락처</dt>
                          {order.cstTelNo ? (
                            <dd>{order.cstTelNo}</dd>
                          ) : (
                            <dd className="null">연락처 정보가 없습니다.</dd>
                          )}
                        </dl>
                        {order?.mobileOrderFg === "20" && order?.tableNm != null ? (
                          <dl className="list_info">
                            <dt>테이블명</dt>
                            {<dd>테이블 {order.tableNm}</dd>}
                          </dl>
                        ) : null}
                        {order.partnerType === "CID" ? (
                          <dl className="list_info">
                            <dt>안심번호</dt>
                            {order?.safeTelNo ? (
                              <dd>{order?.safeTelNo}</dd>
                            ) : (
                              <dd className="null">안심번호가 없습니다.</dd>
                            )}
                          </dl>
                        ) : null}
                        <div className="line"></div>
                        <dl className="list_info">
                          <dt>{order.partnerType === "CID" ? "주방요청" : "가게요청"}</dt>
                          {/* {
                                                        (order.shopMessage) ?
                                                            <dd>{order.shopMessage} {(order.hookComment == null) ? null : " / " + order.hookComment}</dd>
                                                            : <dd className="null">
                                                                {(order.partnerType === "CID") ? "주방요청 메시지가 없습니다" : "가게 요청사항이 없습니다"}
                                                            </dd>
                                                    } */}
                          {
                            <dd>
                              {order?.shopMessage ? order?.shopMessage : ""}
                              {order?.shopMessage != null && order?.hookComment != null ? " / " : ""}
                              {order?.hookComment == null ? null : order?.hookComment}
                            </dd>
                          }
                        </dl>
                        {order?.partnerType === "CID" ? (
                          <dl className="list_info">
                            <dt>고객요청</dt>
                            {order?.dlvMessage ? (
                              <dd>{order?.dlvMessage}</dd>
                            ) : (
                              <dd className="null">고객요청 메시지가 없습니다</dd>
                            )}
                          </dl>
                        ) : order?.orderType === "DELIVERY" ? (
                          <dl className="list_info">
                            <dt>라이더요청</dt>
                            {order?.dlvMessage ? (
                              <dd>{order.dlvMessage}</dd>
                            ) : (
                              <dd className="null">라이더 요청사항이 없습니다</dd>
                            )}
                          </dl>
                        ) : null}
                        {order?.reservedTime ? (
                          <dl className="list_info">
                            <dt className="point">예약시간</dt>
                            <dd className="point">{order.reservedTime + " 예약 주문"}</dd>
                          </dl>
                        ) : null}
                        <dl className="list_info">
                          <dt>매장메모</dt>
                          {order?.shopMemo ? (
                            <dd>{order?.shopMemo}</dd>
                          ) : (
                            <dd className="null">매장 메모가 없습니다</dd>
                          )}
                        </dl>
                      </div>
                      <div className="btns">
                        <button type="button" className="btn_up" onClick={event => fn_scroll_up(this.orderInfo)}>
                          <span></span>
                        </button>
                        <button type="button" className="btn_down" onClick={event => fn_scroll_down(this.orderInfo)}>
                          <span></span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="f_l">
                    {order?.orderType === "DELIVERY" &&
                    (order?.stepCd === "500" || order?.stepCd === "700" || order?.stepCd === "900") ? (
                      order?.dlvStatusFg === null || order?.dlvStatusFg === "99" ? null : (
                        <OrderDetailDeliveryInfo rootStore={rootStore} order={order} />
                      )
                    ) : null}
                    <div className="wrap_menu">
                      <div className="box_tit">
                        <h2>메뉴</h2>
                        <p className="pay">
                          <em>{order?.mainMenuCount}개</em>
                          <span className="txt_bar">|</span>
                          <strong>{comma(order?.orderAmount)}원</strong>
                          {order?.payTypeView === "선불" || order?.payTypeView === "후불"
                            ? "(" + order.payTypeView + ")"
                            : order.payTypeView}
                        </p>
                      </div>
                      <div className="inner">
                        <div
                          className={
                            "scroll_hidden " +
                            (order?.orderType === "DELIVERY" &&
                            (order?.stepCd === "500" || order?.stepCd === "700" || order?.stepCd === "900")
                              ? order?.dlvStatusFg === null || order?.dlvStatusFg === "99"
                                ? "scroll_h_full"
                                : "scroll_h_half"
                              : "scroll_h_full")
                          }
                          ref={this.menuInfo}
                        >
                          {Array.isArray(order.viewProds) && order.viewProds.length > 0
                            ? order.viewProds.map((prod, index) => {
                                return (
                                  <div
                                    key={"prod" + index}
                                    className={
                                      "box_item " + (prod.prodType !== "M" && prod.prodType != null ? "box_item_s" : "")
                                    }
                                  >
                                    <strong className="name">{prod.prodName}</strong>
                                    <span className="num">{prod.saleQty}</span>
                                    <em className="pay">{prod.prodType === "O" ? "" : comma(prod.salePrice)}</em>
                                  </div>
                                );
                              })
                            : null}

                          <dl className="list_pay">
                            <dt>주문금액</dt>
                            <dd>{comma(order.orderTotAmount)}</dd>
                            {order.totDcAmount && order.totDcAmount > 0 ? (
                              <>
                                <dt>할인금액</dt>
                                <dd>- {comma(order.totDcAmount)}</dd>
                              </>
                            ) : (
                              ""
                            )}
                            {order.isPartialCanceled ? (
                              <>
                                <dt>부분취소 금액 합계</dt>
                                <dd>{comma(order.partialCancelAmount)}</dd>
                              </>
                            ) : (
                              ""
                            )}
                          </dl>
                          <dl className="list_total">
                            <dt>
                              <strong>합계</strong> {payText}
                            </dt>
                            <dd>{comma(order?.orderAmount)}</dd>
                          </dl>
                          <div
                            className={
                              order?.orderType === "DELIVERY" &&
                              (order?.mobileOrderFg === "22" ||
                                order?.mobileOrderFg === "29" ||
                                order?.mobileOrderFg === "30" ||
                                order?.mobileOrderFg === "32" ||
                                order?.mobileOrderFg === "52") &&
                              (order?.partnerType === "BAEMINONE" ||
                                order?.partnerType === "COUPANG" ||
                                order?.partnerType === "BAEMIN1" ||
                                order?.partnerType === "BAEMINSTORE" ||
                                order?.partnerType === "PANDASELF" ||
                                order?.partnerType === "DDANGBAEDAL")
                                ? "dlv_tip"
                                : "hide"
                            }
                          >
                            <span className="name">배달팁</span>
                            <em className="pay">
                              {order.referDeliveryAmt === "0" || order.referDeliveryAmt === null
                                ? "0"
                                : comma(order.referDeliveryAmt)}{" "}
                            </em>
                          </div>
                        </div>
                        <div className="btns">
                          <button type="button" className="btn_up" onClick={event => fn_scroll_up(this.menuInfo)}>
                            <span></span>
                          </button>
                          <button type="button" className="btn_down" onClick={event => fn_scroll_down(this.menuInfo)}>
                            <span></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {baeminMobileOrderFg(order?.mobileOrderFg) ? (
                <BaeminOrderDetailButton rootStore={rootStore} order={order} />
              ) : posOrdermMbileOrderFg(order?.mobileOrderFg) ? (
                <PosOrderDetailButton rootStore={rootStore} order={order} />
              ) : (
                <OrderDetailButton rootStore={rootStore} order={order} />
              )}

              <div className="btn_close">
                <button onClick={event => fn_closeDetailView(rootStore)}>
                  <span>닫기</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default OrderDetail;
